import { useConversionBandModel } from '@/components/shared/conversion-band/conversion-band.model'
import { ConversionBandView } from '@/components/shared/conversion-band/conversion-band.view'

export function ConversionBandViewModel() {
  const model = useConversionBandModel()
  return <ConversionBandView {...model} />
}
